import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/markdown.css';
import './styles/highlight.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// Import and initialize PDF.js worker before any components render
import './utils/pdfWorkerSetup';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
